import type { CardHooks } from "./registry";

/**
 * The First Fight — "If your weapons are exhausted +1 power."
 *
 * Wiring note: when onAttackPlay fires, the engine has already added the
 * just-played card to the player's `attackDefendZone` and stored any
 * power/block override under that copy id in `self.adValueOverrides`.
 * Queuing a `next-attack` buff would be wrong — that bonus would skip the
 * current attack and apply to a *future* attack. Instead we mutate the
 * override map for the freshly-played copy so the +1 lands on this attack.
 *
 * Precondition: requires AT LEAST ONE weapon equipped AND every equipped
 * weapon to be tapped (exhausted). Without the length guard, `every` on an
 * empty array returns `true` and the bonus would always apply.
 */
export const theFirstFight: CardHooks = {
  onAttackPlay: (ctx) => {
    const equipped = ctx.self.equipSlots.filter((s) => s.cardId);
    if (equipped.length === 0) return {};
    const allTapped = equipped.every((s) => s.tapped);
    if (!allTapped) return {};

    // The most recent attackDefendZone entry on self is the card we just played.
    const lastEntry = ctx.self.attackDefendZone[ctx.self.attackDefendZone.length - 1];
    if (!lastEntry || lastEntry.side !== "attack") return {};

    const ovr = new Map(ctx.self.adValueOverrides);
    const base = Number(ctx.card.attackDefendFields?.powerValue ?? 0) || 0;
    const current = ovr.get(lastEntry.id);
    ovr.set(lastEntry.id, (current ?? base) + 1);

    return {
      selfPatch: { adValueOverrides: ovr },
      log: ["The First Fight — weapons exhausted, +1 power to this attack"],
    };
  },
};
